<template>
    <div class="products" data-aos="fade-right" :style="{
        position:top>height?'fixed':'absolute',
        top:top>height?'160px':'80px',
    }">
        <el-menu
          :defaultActive="defaultActive"
          class="el-menu-vertical-demo "
          @select="handleSelect"
          >
          <el-menu-item v-for="item,index in productsList" :index="item.src" :disabled="index===0">
              <span v-if="item.title !== 'logo'">{{item.title}}</span>
              <img :src="item.src" alt="" height="36px">
          </el-menu-item>
        </el-menu>
    </div>
</template>

<script>
export default {
    data(){
      return {
        productsList:[
            {
              title:'logo',
              src:require('@/assets/navLogo.png'),
            },
            {
              title:'公司简介',
              src:'/about/introduction'
            },
            {
              title:'新闻报道',
              src:'/about/news'
            },
            {
              title:'热招职位',
              src:'/about/position'
            },
            {
              title:'联系我们',
              src:'/about/contact'
            }
        ],
        defaultActive:'/about/introduction',
        top:0,
        height:window.innerHeight - 243,
      }
    },
    mounted() {
        // 监听滚动事件
        window.addEventListener('scroll', this.handleScroll, true)
        if(this.$route.path == '/about/newsItem'){
          this.defaultActive = '/about/news'
        }else {
          this.defaultActive = this.$route.path
        }

        if (this.defaultActive === '/about/contact'){
            this.height = window.innerHeight *2 -300
        }else if(this.defaultActive === '/about/academic'){
            this.height = window.innerHeight - 220
        }else if(this.defaultActive === '/about/position'){
            this.height = window.innerHeight - 185
        }
    },
    methods:{
        handleScroll(){
          let top = Math.floor(document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset)
            console.log(top)
            console.log(this.height)
          this.top = top
        },
        handleSelect(src){
            this.$emit('aboutSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
.products{
    position: absolute;
    left: 10px;
    top: 80px;
    z-index: 999999;
    visibility: visible!important;
    .el-menu-vertical-demo{
        background: none;
        border-right: none;
        .el-menu-item{
            width: 340px;
            height: 65px;
            box-sizing: border-box;
            padding: 0;
            line-height: 65px;
            text-align: center;
            font-size: 18px;
            margin-bottom: 2px;
            background: #ededed;
            letter-spacing: 3px;
        }
        .el-menu-item:nth-child(1){
            cursor: auto;
             background: #ededed!important;
             opacity: 1;
        }
        .is-active{
            background: #ed1c25;
            border-left: 5px solid #a50006;
            span{
                color: #fff;
            }
        }
    }
}

</style>
